import api from '@/api'
import axios from 'axios'
//获取购物车
export async function getCartItems() {
  return api.get('api/services/app/FrontendCarts/GetCartItems')
}





// WEBPACK FOOTER //
// ./src/api/cart.js